// Malinois Writers — bilingual content source of truth.
// ES = official copy v18 (verbatim from Malinois - Copy para Web v18.docx).
// EN = official copy v18 (verbatim from Malinois - Copy para Web v18 Ingles.docx).
// Rule: every "espacio"/"space" from the doc becomes a paragraph boundary (array item).
// Rule: every "título"/"title" becomes its own bold heading block.
// The literal words "título" / "espacio" / "title" / "space" are never rendered.
// Spanish is the primary language ("/"). English lives under "/en".

export const content = {
  es: {
    lang: "es",
    nav: {
      about: "Sobre",
      services: "Servicios",
      contact: "Contacto",
      cta: "Hablemos de tu Negocio",
      guideCta: "Descargar guía gratis",
    },
    guideModal: {
      title: "El vendedor de IA que ya vive en el WhatsApp de tus clientes",
      subtitle:
        "Descubre la nueva forma de automatización que te permite responder a más clientes sin necesidad de que tú lo hagas manualmente.",
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Correo electrónico",
      submit: "Descargar guía gratis",
      submitting: "Enviando…",
      success: "¡Listo! Tu guía se está descargando.",
      privacy: "Tus datos son solo para enviarte contenido útil. Cero spam.",
      close: "Cerrar",
      errorGeneric: "Algo salió mal. Vuelve a intentarlo en un momento.",
    },
    announcement: null,
    marqueePhrases: [
      "Malinois Writers: Trained for your Brand’s Mission.",
    ],
    faq: {
      title: "Preguntas frecuentes",
      items: [
        {
          q: "¿Trabajan en inglés y español?",
          a: "Sí. Construimos comunicación en español, inglés o ambos, según tu audiencia y el mercado en el que compites.",
        },
        {
          q: "¿Solo trabajan con negocios hispanos?",
          a: "No. Trabajamos con cualquier tipo de negocio. Nuestro foco son founders y empresas hispanas en Estados Unidos, pero no es exclusivo.",
        },
        {
          q: "¿Cuánto dura y cuánto cuesta un proyecto?",
          a: "Cada negocio y cada estrategia son distintos. El costo y el tiempo de ejecución se calculan a partir de eso.",
        },
        {
          q: "¿Cómo empieza un proyecto?",
          a: "Cuéntanos qué estás construyendo. Agendamos una llamada, entendemos el problema y en menos de 48 horas te llega la propuesta.",
        },
      ],
    },
    footer: {
      privacy: "Política de privacidad",
      email: "digitalmedia@malinoisfilms.com",
      rights: "© 2026 Malinois Writers",
      tagline: "Estudio de brand storytelling y copywriting estratégico.",
    },
    // Home copy — v20 (verbatim from "Malinois Web - v20 Español.docx"),
    // remapped into the v21 UX architecture: every word from the v20 doc is
    // kept as written; only the ORDER of blocks changes to fit sections
    // that already exist in Home.jsx. Sections with no v20 equivalent
    // (What To Expect, the Fit/No-Fit filter) were dropped rather than
    // invented; whatWeDo.services / howWeWork.steps are kept from v21 as
    // supplementary UX (v20 doesn't contradict them, just doesn't detail
    // them at that level).
    home: {
      meta: {
        title: "Malinois Writers — Copywriting y sistemas de captación para negocios hispanos",
        description:
          "Estudio de copywriting, ghostwriting y sistemas de captación de clientes calificados para founders y negocios hispanos en Estados Unidos.",
      },
      kicker: "Copywriting + ghostwriting bilingüe para negocios hispanos en Estados Unidos",
      heroTitle:
        "Hay un cliente que muchos empresarios hispanos en Estados Unidos temen, y le temen más que a una carta del IRS.",
      heroSub: [
        "No puedo decir su nombre completo, pero ¿conoces a un tal C.W.?",
        "No es un estafador de película.",
        "Es peor, porque su forma de operar es legal.",
        "Y esta historia también.",
        "¿Te imaginas trabajar para alguien y que luego tengas que pagarle por tu propio trabajo?",
        "Esa es la modalidad de C.W.",
      ],
      heroSubEmphasisIndex: 5,
      heroCta: "Hablemos de tu negocio",
      heroScrollCta: "Conoce la historia",
      heroTransition: [
        "Pero antes de contarte la historia completa,",
        "es mejor que entres en contexto con la realidad de muchos negocios en Estados Unidos.",
      ],
      market: {
        title:
          "El mercado hispano es uno de los principales motores económicos de EE. UU.",
        cubes: [
          { value: 4.4, prefix: "$", suffix: "T", decimals: 1, label: "La cuarta economía más grande del mundo, si se midiera como un país independiente." },
          { value: 28.2, suffix: "%", decimals: 1, label: "del crecimiento total del PIB de Estados Unidos en 2024." },
          { value: 58.7, suffix: "%", decimals: 1, label: "del crecimiento de la fuerza laboral del país desde 2010." },
        ],
        source: "Fuente: Latino Donor Collaborative — U.S. Latino GDP Report, 2025.",
        paragraphs: [
          "Dentro de este contexto, hay negocios que tienen mejor calidad que la competencia.",
          "Mejor producto, mejores ideas, mejores resultados para el cliente.",
          "Y aun así, ven cómo su competencia es la que siempre cierra los contratos.",
          "No es falta de profesionalismo ni de calidad.",
        ],
        statement: "Es lo que pasa cuando no sabes expresar lo que realmente vales.",
        closing: [
          "Y como consecuencia, no solo tu competencia opaca el valor de tu negocio,",
          "sino que, también atraes a los peores clientes",
          "los que tienen un perfil parecido al de C.W.",
        ],
      },
      storyReal: {
        eyebrow: "HISTORIA REAL",
        title: "La historia real de C.W y muchos estafadores en Estados Unidos.",
        paragraphs: [
          "Conocí a un pintor inmigrante en la Costa Este de Estados Unidos. Veinte años de experiencia. El tipo de trabajo que la gente recomienda sin que se lo pidan.",
          "Quería dar el siguiente paso: dejar de depender de contratistas que le pagan lo mínimo, y por fin cobrar el verdadero valor de su trabajo.",
          "Contrató una agencia de marketing milagrosa, esas que siempre te bombardean de anuncios en las redes para multiplicar tus ventas.",
          "Llegaron leads, obviamente de mala calidad.",
        ],
        isolatedLine: "Y llegó C.W.",
        paragraphs2: [
          "Al principio pareció un cliente profesional y de buen presupuesto. Pidió acelerar con contratos ambiguos, “para no perder tiempo”.",
          "El pintor aceptó de la emoción.",
          "Una semana se convirtió en dos, y dos en tres.",
          "El pintor seguía pintando y puliendo cada detalle del servicio, el cual era una cantidad de paga considerable.",
          "A la cuarta semana, a C.W. no le gustó el acabado.",
          "No hubo drama. Solo un mensaje tranquilo:",
        ],
        quote: "Te voy a demandar",
        paragraphs3: [
          "así, directo",
          "y que además termine el trabajo. Sin costo adicional.",
          "El pintor sintió lo que muchos inmigrantes hispanos alguna vez han experimentado:",
          "el peso de pelear una situación compleja que le iba a costar más que ceder.",
          "Cedió. Devolvió todo el dinero que ya había cobrado.",
          "Y encima, terminó ese último mes de trabajo gratis, para evitar ir al Municipal Court.",
          "Un mes entero de su vida, regalado a alguien que nunca pensó pagarle.",
        ],
        closingStatement: [
          "Esta no es una anécdota nueva. Es una modalidad conocida",
          "es la amenaza legal usada como palanca de negociación",
          "que muchos ciudadanos aprovechados usan específicamente contra empresarios inmigrantes en Estados Unidos.",
        ],
      },
      revelation: {
        title: "Pero acá está el detalle: esto nunca fue sobre un mal acabado de pintura.",
        paragraphs: [
          "C.W. busca a quién no proyecta lo que vale, para aprovecharse de él.",
        ],
        bigQuestion:
          "¿Crees que C.W. hubiera intentado lo mismo con una marca de pintura como Sherwin Williams?",
        afterQuestion: [
          "No. Porque Sherwin Williams transmite autoridad.",
          "Y seguramente C.W. hubiera terminado contrademandado por siquiera intentarlo.",
        ],
        statementPart1: "Si tienes una ventaja de valor real y no la muestras,",
        statementPart2: "es exactamente lo mismo que no tenerla.",
      },
      whyCantInvoice: {
        title: "¿Por qué no puedes facturar?",
        paragraphs: [
          "Mira tus perfiles digitales,",
          "cada mensaje que publicas dice algo sobre cuánto vale lo que construiste.",
          "Cuando no lo transmites, tu marca suena igual que la mayoría.",
          "Y ahí el mercado no te trata con respeto.",
        ],
        closing: [
          "Eso no se arregla trabajando más horas o invirtiendo publicidad barata en Meta Ads.",
          "Se arregla construyendo la comunicación e identidad de tu negocio,",
          "y por supuesto, dejando de sonar igual que tu competencia.",
        ],
        cta: "Hablemos de tu Negocio",
      },
      advantage: {
        title: "La ventaja que ya tienes",
        intro: "Si vienes de una familia, una cultura o una identidad hispana en Estados Unidos, tienes puntos extras que la mayoría:",
        emphasisLine: "sabes moverte en dos culturas al mismo tiempo.",
        paragraphs: [
          "Puedes entender cómo piensa un inversionista americano.",
          "Y al mismo tiempo, entiendes lo que valora el mercado hispano,",
        ],
        statement: ["La ventaja es tuya.", "Y casi nunca la estás usando."],
        convergeLeft: "U.S. MARKET",
        convergeRight: "HISPANIC CULTURE",
      },
      forThatExists: {
        eyebrow: "MALINOIS WRITERS",
        title: "Para eso existe Malinois Writers",
        paragraphs: [
          "Entendemos cómo se construye valor a través del copywriting y el ghostwriting bilingüe para:",
          "Inversionistas, dueños de empresas y startups hispanas.",
          "También entendemos el mundo hispano del que viene tu historia,",
          "tu identidad y cultura.",
        ],
        reinforcement: {
          lines: ["Tu negocio no necesita más leads", "Necesita mejores oportunidades"],
          subtext:
            "Escribimos el mensaje que hace que el prospecto correcto se detenga, y construimos el sistema que le da seguimiento hasta que está listo para que tu equipo cierre la venta.",
        },
      },
      why: {
        title: "¿Por qué Malinois Writers?",
        left: {
          label: "DOMINIO TÉCNICO",
          text: "Cualquier agencia en Estados Unidos puede entender este mercado. Pocas entienden la identidad detrás de tu marca.",
        },
        right: {
          label: "IDENTIDAD CULTURAL",
          text: "No la traducimos desde otro país. La escribimos desde adentro, en el mismo mercado donde compites.",
        },
        center: ["Malinois no elige entre uno y otro.", "Trabaja con los dos al mismo tiempo — igual que tú."],
      },
      whatWeDo: {
        title: "Lo que hacemos",
        paragraphs: [
          "ghostwriting bilingüe, copywriting para redes sociales, sitios web y guiones de video.",
          "Cada estrategia tiene como fin aumentar tus ventas.",
        ],
        services: [
          {
            number: "01",
            title: "Conversión",
            colorKey: "lime",
            text: "Diseñamos agentes digitales de prospección: hablan automáticamente con los decisores de tus clientes calificados.",
            deliverables: ["Agentes de Prospección", "Landing Pages", "Website Copy", "Chatbots"],
          },
          {
            number: "02",
            title: "Video",
            colorKey: "orange",
            text: "Cualquiera puede generar contenido en segundos. Pocas ideas merecen que alguien se detenga a escucharlas.",
            deliverables: ["VSL", "Guiones de video", "Podcast", "Social Video", "Narrativas de campaña"],
          },
          {
            number: "03",
            title: "Voz de Marca",
            colorKey: "cobalt",
            text: "La IA puede ayudarte a producir más. Tu voz es lo que hace que te recuerden. Transformamos tu experiencia y criterio en una voz ejecutiva propia para LinkedIn, email y contenido B2B.",
            deliverables: ["Ghostwriting ejecutivo", "Email", "Brand Voice", "Auditoría de comunicación", "Copy para redes"],
          },
        ],
        cta: "Ver todos los servicios",
      },
      howWeWork: {
        title: "¿Cómo trabajamos?",
        intro: [
          "Estudiamos el mercado, tu negocio y hacemos una estrategia acorde a lo que tu marca necesita.",
          "Lo que funciona para ti no necesariamente funciona para los demás.",
        ],
        steps: [
          {
            number: "01",
            title: "Estudiamos",
            text: "Tu negocio, mercado, cliente y competencia. Antes de escribir necesitamos entender qué estás vendiendo y dónde estás compitiendo.",
          },
          {
            number: "02",
            title: "Encontramos",
            text: "Identificamos qué hace diferente a tu negocio y qué parte de ese valor no está llegando al mercado.",
          },
          {
            number: "03",
            title: "Construimos",
            text: "Definimos la estrategia, los mensajes y la forma en que tu marca necesita expresarlos.",
          },
          {
            number: "04",
            title: "Escribimos",
            text: "Convertimos la estrategia en las piezas que realmente necesitas: web, ghostwriting, email, video o sistemas de conversión.",
          },
        ],
      },
      oneMoreThing: {
        title: "Una cosa más:",
        paragraphs: [
          "No somos el partner correcto para todos, y está bien.",
          "Trabajamos mejor con founders y negocios que no buscan una fábrica de contenido ni publicar por publicar. Buscan que su comunicación esté a la altura de lo que ya han construido: una oferta sólida, experiencia real y resultados que merecen atraer clientes del mismo nivel.",
          "Si tu negocio ya tiene valor, pero todavía no se percibe con la misma claridad en tu mensaje, tu contenido o tu presencia digital, hablemos.",
        ],
      },
      finalCall: {
        title: "Cuéntanos qué construyes",
        subtitle: "y en menos de 48 horas te decimos si podemos escalar tu negocio juntos.",
        cta: "hablemos de tu negocio",
        tagline: "Malinois Writers: Trained for your Brand’s Mission",
      },
    },
    about: {
      meta: {
        title: "Sobre Malinois — Malinois Writers",
        description:
          "Conoce a Malinois Writers: qué somos, en qué creemos y quién está detrás de este estudio de copywriting bilingüe para negocios hispanos en Estados Unidos.",
      },
      kicker: "SOBRE MALINOIS",
      title: "Sobre Malinois",
      sections: [
        {
          title: "Por qué Malinois",
          paragraphs: [
            "Malinois es una raza de perro pastor belga. No es el popular labrador ni la mascota tierna para tener en casa; es una de las razas más queridas en el mundo perruno. Es conocido por ser altamente inteligente, protector y uno de los mejores para entrenar.",
            "Elegimos ese nombre porque representa lo que hacemos: estamos entrenados para la misión de tu marca. Y porque amamos los perros también.",
          ],
          tagline: "De ahí sale nuestro lema: Trained for your brand’s mission.",
        },
        {
          title: "Quiénes somos",
          paragraphs: [
            "Malinois Writers nació como una idea en San Jose, California, debido a que su fundador tuvo la oportunidad de conocer a muchos empresarios hispanos en su trayecto por Estados Unidos, y todos convergían en el mismo problema: la desvalorización de sus marcas en el mercado norteamericano.",
            "Somos un equipo de copywriters y profesionales con experiencia en escritura creativa, storytelling y videografía para startups y negocios digitales. Y al igual que tú, somos inmigrantes nativos digitales que trabajan desde cualquier parte del mundo escalando negocios.",
          ],
        },
        {
          title: "Por qué existimos",
          paragraphs: [
            "Para potenciar el valor de las marcas, especialmente de inmigrantes, en el mercado americano. Sabemos que muchos inmigrantes tienen el talento y la formación necesaria para escalar y salir adelante, y que sus marcas son incluso de mejor calidad que muchas ya existentes en el mercado americano. Pero sobre todo, existimos para ser el amigo fiel que está entrenado para escalar sus negocios.",
          ],
        },
      ],
      beliefsTitle: "En qué creemos",
      beliefs: [
        "La identidad no es un detalle de tu historia. Es tu ventaja competitiva.",
        "La honestidad no es cortesía. Es la única ventaja que ningún competidor te puede copiar.",
        "No hay que nacer en Estados Unidos para ser exitoso.",
      ],
      founder: {
        title: "El fundador",
        name: "Antonio Salas",
        role: "Founder, Malinois Writers",
        paragraphs: [
          "Antonio Salas viene del mundo audiovisual y la publicidad digital. Su talento se formó en la creatividad digital enfocada al storytelling y la postproducción audiovisual. A lo largo de su carrera ha trabajado con marcas B2B en el mercado internacional y en proyectos artísticos como el cortometraje Trainloop, nominado en premios de shortfilms en Toronto. Actualmente implementa también sistemas de IA para negocios y startups hispanas como Livienda.",
          "En su experiencia recorriendo Estados Unidos, pudo conocer de cerca a empresarios hispanos que inspiraron Malinois.",
          "Vio el mismo patrón demasiadas veces: talento de sobra, marcas de calidad y un mercado que aun así los trataba como si valieran menos. Malinois Writers es su respuesta a ese patrón.",
          "Como hobby, ama el cine, la escritura creativa y editar videos para sus amigos.",
        ],
      },
      closingSentences: [
        "No somos una fábrica de contenido ni una agencia de fórmulas empaquetadas.",
        "Somos los que te entrenan para destacar tu valor.",
        "Ese que el mercado aún no sabe que tienes.",
      ],
      cta: "Hablemos de tu negocio",
      tagline: "Malinois Writers. Trained for your brand’s mission.",
    },
    contact: {
      meta: {
        title: "Contacto / Agendar llamada — Malinois Writers",
        description:
          "Cuéntanos qué construyes y para quién. En menos de 48 horas te decimos si Malinois puede ayudarte a escalar tu negocio.",
      },
      kicker: "AGENDAR LLAMADA",
      title: "Antes de cualquier propuesta, necesito entender lo que estás construyendo.",
      intro:
        "Cuéntame qué haces, para quién, y qué está fallando en cómo lo comunicas hoy. En menos de 48 horas te digo si puedo ayudarte a escalar.",
      introAttr: "— Antonio Salas, Founder",
      form: {
        fullName: "Nombre completo",
        email: "Email",
        phone: "Teléfono",
        company: "Empresa o proyecto",
        whatBuild: "¿Qué construyes y para quién?",
        frustration: "¿Cuál es tu mayor frustración con cómo comunicas tu negocio hoy?",
        tractionLabel: "¿Tienes resultados, clientes o trayectoria real que mostrar?",
        tractionYes: "Sí — tengo casos, clientes o resultados concretos",
        tractionNo: "Todavía no — estoy en etapa de idea",
        submit: "Enviar",
        submitting: "Enviando...",
        required: "Este campo es obligatorio",
        invalidEmail: "Ingresa un email válido",
        invalidPhone: "Ingresa un teléfono válido",
      },
      qualifiedMessage:
        "Recibí tu mensaje. Revisaré tu situación y te escribo en menos de 48 horas si Malinois puede ayudarte a escalar.",
      disqualifiedMessage:
        "Malinois trabaja con negocios que ya tienen algo real que comunicar. Cuando tengas tracción, clientes o resultados que mostrar, escríbenos. Estaremos aquí.",
      calendlyTitle: "Agenda tu llamada",
      calendlyPlaceholder: "El calendario de Antonio se conectará aquí muy pronto. Mientras tanto, revisaremos tu mensaje manualmente y te contactaremos por email.",
      errorMessage: "Hubo un problema enviando tu mensaje. Intenta de nuevo.",
      newMessage: "Enviar otro mensaje",
    },
    services: {
      meta: {
        title: "Servicios — Malinois Writers",
        description:
          "Video, Voz de Marca y Conversión y Automatización: el catálogo completo de lo que escribimos y construimos en Malinois Writers.",
      },
      kicker: "SERVICIOS",
      title: "Tres formas de resolver un mismo problema",
      subtitle: "Cada categoría ataca una parte distinta de tu comunicación. Elige por dónde empezar.",
      forQuienLabel: "Para quién es",
      incluyeLabel: "Qué incluye",
      railHint: "Servicios",
      cardCta: "Hablemos de tu negocio",
      chapters: [
        {
          key: "conversion",
          number: "01",
          label: "Conversión y Automatización",
          railLabel: "Conversión",
          color: "lime",
          blurb: "Páginas y sistemas que convierten prospectos en clientes.",
          items: [
            {
              title: "Agentes de Prospección",
              forQuien: [
                "Founders y negocios B2B que necesitan encontrar prospectos calificados y hablar directo con sus decisores, sin pasar por procesos burocráticos.",
              ],
              incluye: [
                "Diseñamos un agente digital que identifica, contacta y conversa con los decisores de tus clientes ideales.",
                "Tú solo cierras la venta cuando ya hay una conversación calificada esperando.",
              ],
            },
            {
              title: "Landing Pages",
              forQuien: [
                "Negocios y startups con una oferta clara que necesitan una página enfocada en una sola acción: comprar, solicitar información, reservar una llamada o registrarse.",
              ],
              incluye: [
                "Diseñamos el mensaje completo, desde el primer titular hasta el CTA final.",
                "Investigamos tu oferta, tu cliente y sus objeciones para construir una página que responda las preguntas correctas y facilite la decisión.",
              ],
            },
            {
              title: "Website Copy",
              forQuien: [
                "Negocios que necesitan lanzar, renovar o reposicionar una web que ya no refleja el nivel de su empresa ni explica con claridad lo que ofrecen.",
              ],
              incluye: [
                "Arquitectura de mensajes, experiencia de usuario y copywriting estratégico para que tu propuesta se entienda de inmediato.",
                "Y aparezca mejor tanto en buscadores como en las nuevas búsquedas impulsadas por IA.",
              ],
            },
            {
              title: "Chatbots y Flujos Conversacionales",
              forQuien: [
                "Negocios que reciben consultas de forma constante y necesitan atender, orientar o calificar prospectos incluso cuando nadie del equipo está disponible.",
              ],
              incluye: [
                "Diseñamos la lógica y la conversación completa: preguntas, respuestas, rutas y próximos pasos.",
                "El objetivo no es hacer que un bot \"hable\", sino crear una experiencia útil que responda, filtre y conduzca al cliente sin sentirse robótica.",
              ],
            },
          ],
        },
        {
          key: "video",
          number: "02",
          label: "Video",
          railLabel: "Video",
          color: "orange",
          blurb: "Guiones que venden y que la gente se queda viendo hasta el final.",
          items: [
            {
              title: "Guiones para Video de Venta (VSL)",
              forQuien: [
                "Founders y startups que venden de forma digital y necesitan un video que explique su oferta, resuelva objeciones y lleve al prospecto a decidir.",
              ],
              incluye: [
                "Guion completo de 5 a 15 minutos, construido alrededor de tu oferta y lo que tu cliente duda antes de comprar.",
                "Incluye edición de video.",
              ],
            },
            {
              title: "Guiones para Reels & Shorts",
              forQuien: [
                "Founders y marcas B2B que publican video corto y necesitan retener a su audiencia en los primeros 3 segundos.",
              ],
              incluye: [
                "Guiones que enganchan desde el primer segundo y sostienen la idea hasta el final.",
                "Incluye edición de video.",
              ],
            },
            {
              title: "Guiones para YouTube y Podcast",
              forQuien: [
                "Founders y expertos que quieren construir autoridad y confianza con contenido de formato largo, sin perder relevancia.",
              ],
              incluye: [
                "Estructura y guion que convierten conocimiento complejo en episodios claros y fáciles de seguir.",
                "Incluye edición de video.",
              ],
            },
          ],
        },
        {
          key: "voz",
          number: "03",
          label: "Voz de Marca",
          railLabel: "Voz de Marca",
          color: "cobalt",
          blurb: "Que tu marca suene a ti, incluso cuando tú no estás escribiendo.",
          items: [
            {
              title: "Ghostwriting Ejecutivo",
              forQuien: [
                "Founders y directivos con experiencia, criterio e ideas valiosas, pero sin el tiempo o sistema para convertirlas en contenido constante.",
              ],
              incluye: [
                "Transformamos tu forma de pensar en contenido escrito en primera persona para LinkedIn, artículos y otros canales.",
              ],
            },
            {
              title: "Email & Newsletters",
              forQuien: [
                "Negocios que ya tienen audiencia, leads o clientes y quieren mantenerse presentes sin depender del algoritmo de las redes sociales.",
              ],
              incluye: [
                "Newsletters, campañas y secuencias de email escritas alrededor de tu voz, tus ideas y tu oferta.",
                "Desde contenido editorial que mantiene la relación, hasta emails que llevan directo a la venta.",
              ],
            },
            {
              title: "Sistema de Voz",
              forQuien: [
                "Empresas en crecimiento cuya comunicación todavía cambia demasiado según quién escribe, qué canal usan o qué herramienta de IA genera el contenido.",
              ],
              incluye: [
                "Definimos el tono y los principios de comunicación de tu marca para que web, emails, redes, ventas y hasta tus herramientas de IA hablen con una misma voz.",
                "Una identidad mucho más difícil de copiar.",
              ],
            },
          ],
        },
      ],
      closing: {
        title: "¿No sabes cuál necesitas?",
        paragraphs: [
          "No tienes que llegar con una lista de servicios elegida.",
          "Cuéntanos qué estás construyendo y qué problema quieres resolver.",
        ],
        statement: "Nosotros encontramos dónde se está perdiendo valor y lo corregimos.",
        cta: "Hablemos de tu negocio",
      },
    },
    privacy: {
      meta: {
        title: "Política de privacidad — Malinois Writers",
        description: "Política de privacidad de Malinois Writers.",
      },
      title: "Política de privacidad",
      updated: "Última actualización: enero 2026",
      body: [
        "Malinois Writers recopila la información que proporcionas voluntariamente a través de nuestro formulario de contacto (nombre, email, empresa y las respuestas que compartes) únicamente para evaluar tu solicitud y responderte.",
        "No vendemos ni compartimos tu información con terceros con fines comerciales. Tus datos se usan exclusivamente para gestionar la comunicación entre tú y Malinois Writers.",
        "Si en algún momento quieres que eliminemos tu información de nuestros registros, escríbenos a digitalmedia@malinoisfilms.com y lo haremos en un plazo razonable.",
      ],
    },
  },
  en: {
    lang: "en",
    nav: {
      about: "About",
      services: "Services",
      contact: "Contact",
      cta: "Let's Talk About Your Business",
      guideCta: "Download free guide",
    },
    guideModal: {
      title: "The AI salesperson already living inside your customers' WhatsApp",
      subtitle:
        "Discover the new kind of automation that lets you respond to more customers without doing it manually yourself.",
      name: "Full name",
      phone: "Phone",
      email: "Email",
      submit: "Download free guide",
      submitting: "Sending…",
      success: "Done! Your guide is downloading.",
      privacy: "We use your info only to send you useful content. Zero spam.",
      close: "Close",
      errorGeneric: "Something went wrong. Please try again in a moment.",
    },
    announcement: null,
    marqueePhrases: [
      "Malinois Writers: Trained for your Brand’s Mission.",
    ],
    faq: {
      title: "Frequently asked questions",
      items: [
        {
          q: "Do you work in both English and Spanish?",
          a: "Yes. We build communication in Spanish, English, or both, based on your audience and the market you compete in.",
        },
        {
          q: "Do you only work with Hispanic businesses?",
          a: "No. We work with any type of business. Our focus is Hispanic founders and companies in the United States, but it's not exclusive.",
        },
        {
          q: "How long does a project take, and how much does it cost?",
          a: "Every business and every strategy is different. Cost and timeline are calculated from that.",
        },
        {
          q: "How does a project start?",
          a: "Tell us what you're building. We set up a call, understand the problem, and you get a proposal within 48 hours.",
        },
      ],
    },
    footer: {
      privacy: "Privacy Policy",
      email: "digitalmedia@malinoisfilms.com",
      rights: "© 2026 Malinois Writers",
      tagline: "Brand storytelling and strategic copywriting studio.",
    },
    home: {
      meta: {
        title: "Malinois Writers — Copywriting & Client-Acquisition Systems",
        description:
          "A copywriting, ghostwriting, and qualified client-acquisition studio for Hispanic founders and businesses in the United States.",
      },
      kicker: "Bilingual copywriting + ghostwriting for Hispanic-owned businesses in the United States",
      heroTitle:
        "There's a client a lot of Hispanic business owners in the United States are afraid of, more afraid of than a letter from the IRS.",
      heroSub: [
        "I can't give you his full name, but have you heard of a guy named C.W.?",
        "He's not some con man out of a movie.",
        "He's worse, because how he operates is legal.",
        "And so is this story.",
        "Can you imagine working for someone and then having to pay them for your own work?",
        "That's C.W.'s playbook.",
      ],
      heroSubEmphasisIndex: 5,
      heroCta: "Let's talk about your business",
      heroScrollCta: "See the whole story",
      heroTransition: [
        "But before I tell you the whole story,",
        "you need some context on what business really looks like for a lot of people in the United States.",
      ],
      market: {
        title:
          "The Hispanic market is one of the main economic engines of the U.S.",
        cubes: [
          { value: 4.4, prefix: "$", suffix: "T", decimals: 1, label: "The fourth-largest economy in the world, if measured as an independent country." },
          { value: 28.2, suffix: "%", decimals: 1, label: "of total U.S. GDP growth in 2024." },
          { value: 58.7, suffix: "%", decimals: 1, label: "of U.S. labor force growth since 2010." },
        ],
        source: "Source: Latino Donor Collaborative — U.S. Latino GDP Report, 2025.",
        paragraphs: [
          "There are businesses out there with better quality than their competitors.",
          "Better product, better ideas, better results for the client.",
          "And still, they watch their competition close the deals every time.",
          "It's not a lack of professionalism or quality.",
        ],
        statement: "It's what happens when you don't know how to express what you're really worth.",
        closing: [
          "And as a result, it's not just your competition dulling your brand's value,",
          "you're also attracting the worst clients",
          "the kind with a profile similar to C.W.'s.",
        ],
      },
      storyReal: {
        eyebrow: "A REAL STORY",
        title: "The real story of C.W. and many scammers in the United States.",
        paragraphs: [
          "I met an immigrant painter on the East Coast of the United States. Twenty years of experience. The kind of work people recommend without being asked.",
          "He wanted to take the next step: stop depending on contractors who paid him the bare minimum, and finally charge what his work was really worth.",
          "He hired a miracle marketing agency, the kind that always floods you with social media ads promising to multiply your sales.",
          "Leads came in, obviously low quality.",
        ],
        isolatedLine: "And C.W. showed up.",
        paragraphs2: [
          "At first, he seemed like a professional client with a solid budget. He asked to speed things up with vague contracts, “so we don't waste time.”",
          "The painter agreed, caught up in the excitement.",
          "One week turned into two, and two into three.",
          "The painter kept painting and polishing every detail of the job, which was a considerable amount of money.",
          "By the fourth week, C.W. didn't like the finish.",
          "There was no drama. Just a calm message:",
        ],
        quote: "I'm going to sue you",
        paragraphs3: [
          "Just like that, direct.",
          "And that he should still finish the job. At no extra cost.",
          "The painter felt something many Hispanic immigrants have experienced at some point:",
          "the weight of fighting a complicated situation that was going to cost him more than giving in.",
          "He gave in. He returned all the money he'd already been paid.",
          "And on top of that, he finished that last month of work for free, to avoid going to Municipal Court.",
          "An entire month of his life, given away to someone who never intended to pay him.",
        ],
        closingStatement: [
          "This isn't a new story. It's a known playbook",
          "it's the legal threat used as a negotiating lever",
          "that a lot of opportunists specifically use against immigrant business owners in the United States.",
        ],
      },
      revelation: {
        title: "But here's the thing: this was never about a bad paint job.",
        paragraphs: [
          "C.W. looks for whoever doesn't project what they're worth, so he can take advantage of them.",
        ],
        bigQuestion:
          "Do you think C.W. would have tried the same thing with a paint brand like Sherwin-Williams?",
        afterQuestion: [
          "No. Because Sherwin-Williams projects authority.",
          "And C.W. would probably have ended up counter-sued for even trying.",
        ],
        statementPart1: "If you have a real advantage in value and you don't show it,",
        statementPart2: "it's exactly the same as not having it.",
      },
      whyCantInvoice: {
        title: "Why can't you charge what you're worth?",
        paragraphs: [
          "Look at your digital profiles,",
          "every message you post says something about how much what you've built is worth.",
          "When you don't communicate it, your brand sounds just like everyone else's.",
          "And that's where the market stops treating you with respect.",
        ],
        closing: [
          "That's not fixed by working more hours or investing in cheap Meta Ads.",
          "It's fixed by building your business's communication and identity,",
          "and, of course, by no longer sounding just like your competition.",
        ],
        cta: "Let's Talk About Your Business",
      },
      advantage: {
        title: "The advantage you already have",
        intro: "If you come from a Hispanic family, culture, or identity in the United States, you have an edge most people don't:",
        emphasisLine: "you know how to move between two cultures at the same time.",
        paragraphs: [
          "You can understand how an American investor thinks.",
          "And at the same time, you understand what the Hispanic market values,",
        ],
        statement: ["The advantage is yours.", "And you're almost never using it."],
        convergeLeft: "U.S. MARKET",
        convergeRight: "HISPANIC CULTURE",
      },
      forThatExists: {
        eyebrow: "MALINOIS WRITERS",
        title: "That's why Malinois Writers exists",
        paragraphs: [
          "We understand how value is built through bilingual copywriting and ghostwriting for:",
          "investors, business owners, and Hispanic startups.",
          "We also understand the Hispanic world your story comes from,",
          "your identity and culture.",
        ],
        reinforcement: {
          lines: ["Your business doesn't need more leads", "It needs better opportunities"],
          subtext:
            "We write the message that makes the right prospect stop, and build the system that follows up until they're ready for your team to close the sale.",
        },
      },
      why: {
        title: "Why Malinois Writers?",
        left: {
          label: "TECHNICAL MASTERY",
          text: "Any agency in the U.S. can understand this market. Few understand the identity behind your brand.",
        },
        right: {
          label: "CULTURAL IDENTITY",
          text: "We don't translate it from another country. We write it from the inside, in the same market where you compete.",
        },
        center: ["Malinois doesn't choose between the two.", "It works with both at once — just like you."],
      },
      whatWeDo: {
        title: "What we do",
        paragraphs: [
          "bilingual ghostwriting, copywriting for social media, websites, and video scripts.",
          "Every strategy exists to increase your sales.",
        ],
        services: [
          {
            number: "01",
            title: "Conversion",
            colorKey: "lime",
            text: "We design digital prospecting agents: they talk automatically with the decision-makers behind your qualified leads.",
            deliverables: ["Prospecting Agents", "Landing Pages", "Website Copy", "Chatbots"],
          },
          {
            number: "02",
            title: "Video",
            colorKey: "orange",
            text: "Anyone can generate content in seconds. Few ideas are worth stopping to listen to.",
            deliverables: ["VSL", "Video scripts", "Podcast", "Social video", "Campaign narratives"],
          },
          {
            number: "03",
            title: "Brand Voice",
            colorKey: "cobalt",
            text: "AI can help you produce more. Your voice is what makes people remember you. We turn your experience and judgment into an executive voice of your own for LinkedIn, email, and B2B content.",
            deliverables: ["Executive ghostwriting", "Email", "Brand voice", "Communication audit", "Social copy"],
          },
        ],
        cta: "See all services",
      },
      howWeWork: {
        title: "How do we work?",
        intro: [
          "we study the market, your business, and build a strategy based on what your brand needs.",
          "What works for you won't necessarily work for someone else.",
        ],
        steps: [
          {
            number: "01",
            title: "We study",
            text: "Your business, market, customer, and competition. Before we write a word, we need to understand what you're selling and where you're competing.",
          },
          {
            number: "02",
            title: "We find",
            text: "We identify what makes your business different, and which part of that value isn't reaching the market.",
          },
          {
            number: "03",
            title: "We build",
            text: "We define the strategy, the messages, and the way your brand needs to express them.",
          },
          {
            number: "04",
            title: "We write",
            text: "We turn the strategy into the pieces you actually need: web, ghostwriting, email, video, or conversion systems.",
          },
        ],
      },
      oneMoreThing: {
        title: "One more thing, honestly:",
        paragraphs: [
          "We're not the right partner for everyone, and that's fine.",
          "We work best with founders and businesses that aren't looking for a content factory with no direction — they want their communication to reflect something real they already have: a solid offer, experience, or results that deserve to be better reflected.",
          "If you've built something with real value and feel your communication isn't matching it yet, let's talk.",
        ],
      },
      finalCall: {
        title: "Tell us what you're building",
        subtitle: "and in less than 48 hours we'll tell you if we can scale your business together.",
        cta: "let's talk about your business",
        tagline: "Malinois Writers: Trained for your Brand’s Mission",
      },
    },
    about: {
      meta: {
        title: "About Malinois — Malinois Writers",
        description:
          "Meet Malinois Writers: what we are, what we believe, and who's behind this bilingual copywriting studio for Hispanic businesses in the United States.",
      },
      kicker: "ABOUT MALINOIS",
      title: "About Malinois",
      sections: [
        {
          title: "Why Malinois",
          paragraphs: [
            "Malinois is a Belgian shepherd breed. It's not the popular labrador or the cute family pet; it's one of the most loved breeds in the dog world. It's known for being highly intelligent, protective and one of the best dogs to train.",
            "We chose that name because it represents what we do: we're trained for your brand's mission. And because we love dogs too.",
          ],
          tagline: "That's where our motto comes from: Trained for your brand's mission.",
        },
        {
          title: "Who We Are",
          paragraphs: [
            "Malinois Writers was born as an idea in San Jose, California, after its founder had the chance to meet many Hispanic business owners on his journey across the United States, and all of them shared the same problem: the undervaluation of their brands in the American market.",
            "We're a team of copywriters and professionals with experience in creative writing, storytelling and videography for startups and digital businesses. And just like you, we're digital-native immigrants working from anywhere in the world, scaling businesses.",
          ],
        },
        {
          title: "Why We Exist",
          paragraphs: [
            "To grow the value of brands, especially immigrant-owned brands, in the American market. We know many immigrants have the talent and the training to scale and get ahead, and that their brands are often better than plenty of what's already out there. But above all, we exist to be the loyal friend that's trained to scale their business.",
          ],
        },
      ],
      beliefsTitle: "What We Believe",
      beliefs: [
        "Your identity isn't a footnote in your story. It's your competitive advantage.",
        "Honesty isn't politeness. It's the one advantage no competitor can copy.",
        "You don't have to be born in the United States to succeed.",
      ],
      founder: {
        title: "The Founder",
        name: "Antonio Salas",
        role: "Founder, Malinois Writers",
        paragraphs: [
          "Antonio Salas comes from the audiovisual and digital advertising world. His craft was built on digital creativity focused on storytelling and audiovisual post-production. Throughout his career, he has worked with B2B brands in the international market and on artistic projects like the short film Trainloop, nominated at short film awards in Toronto. He currently also implements AI systems for Hispanic businesses and startups like Livienda.",
          "Traveling across the United States, he got to know firsthand the Hispanic business owners who inspired Malinois.",
          "He saw the same pattern too many times: talent to spare, quality brands, and a market that still treated them like they were worth less. Malinois Writers is his answer to that pattern.",
          "As a hobby, he loves film, creative writing and editing videos for his friends.",
        ],
      },
      closingSentences: [
        "We're not a content factory or an agency selling prepackaged formulas.",
        "We're the ones who train you to show your value.",
        "The one the market doesn't know you have yet.",
      ],
      cta: "Let's Talk About Your Business",
      tagline: "Malinois Writers. Trained for your brand’s mission.",
    },
    contact: {
      meta: {
        title: "Contact / Book a call — Malinois Writers",
        description:
          "Tell us what you're building and for whom. In less than 48 hours, we'll tell you if Malinois can help you scale your business.",
      },
      kicker: "BOOK A CALL",
      title: "Before any proposal, I need to understand what you're building.",
      intro:
        "Tell me what you do, for whom, and what's failing in how you communicate it today. In less than 48 hours I'll tell you if I can help you scale.",
      introAttr: "— Antonio Salas, Founder",
      form: {
        fullName: "Full name",
        email: "Email",
        phone: "Phone",
        company: "Company or project",
        whatBuild: "What are you building, and for whom?",
        frustration: "What's your biggest frustration with how you communicate your business today?",
        tractionLabel: "Do you have real results, clients, or a track record to show?",
        tractionYes: "Yes — I have real cases, clients, or results",
        tractionNo: "Not yet — I'm at the idea stage",
        submit: "Submit",
        submitting: "Submitting...",
        required: "This field is required",
        invalidEmail: "Enter a valid email",
        invalidPhone: "Enter a valid phone",
      },
      qualifiedMessage:
        "I received your message. I'll review your situation and write back within 48 hours if Malinois can help you scale.",
      disqualifiedMessage:
        "Malinois works with businesses that already have something real to communicate. When you have traction, clients, or results to show, reach out. We'll be here.",
      calendlyTitle: "Book your call",
      calendlyPlaceholder: "Antonio's calendar will be connected here very soon. In the meantime, we'll review your message manually and reach out by email.",
      errorMessage: "There was a problem sending your message. Please try again.",
      newMessage: "Send another message",
    },
    services: {
      meta: {
        title: "Services — Malinois Writers",
        description:
          "The map of what we know how to do: video and voice, AI-proof brand voice, and conversion and automation.",
      },
      kicker: "SERVICES",
      title: "Three ways to solve the same problem",
      subtitle: "Each category tackles a different part of your communication. Pick where to start.",
      forQuienLabel: "Who it's for",
      incluyeLabel: "What's included",
      railHint: "Services",
      cardCta: "Let's talk about your business",
      chapters: [
        {
          key: "conversion",
          number: "01",
          label: "Conversion & Automation",
          railLabel: "Conversion",
          color: "lime",
          blurb: "Pages and systems that turn prospects into customers.",
          items: [
            {
              title: "Prospecting Agents",
              forQuien: [
                "Founders and B2B businesses that need to find qualified prospects and talk directly to their decision-makers, without getting stuck in bureaucratic processes.",
              ],
              incluye: [
                "We design a digital agent that identifies, reaches out to, and talks with the decision-makers behind your ideal customers.",
                "You only close the deal once there's already a qualified conversation waiting.",
              ],
            },
            {
              title: "Landing Pages",
              forQuien: [
                "Businesses and startups with a clear offer that need a page built around a single action: buy, request information, book a call, or sign up.",
              ],
              incluye: [
                "We design the complete message, from the first headline to the final CTA.",
                "We research your offer, your customer, and their objections to build a page that answers the right questions and makes the decision easier.",
              ],
            },
            {
              title: "Website Copy",
              forQuien: [
                "Businesses that need to launch, renew, or reposition a website that no longer reflects their company's level or clearly explains what they offer.",
              ],
              incluye: [
                "Message architecture, user experience, and strategic copywriting so your offer is understood instantly.",
                "And shows up better both in search engines and in the new AI-powered discovery experiences.",
              ],
            },
            {
              title: "Chatbots & Conversational Flows",
              forQuien: [
                "Businesses that get constant inquiries and need to respond, guide, or qualify prospects even when no one on the team is available.",
              ],
              incluye: [
                "We design the full logic and conversation: questions, answers, paths, and next steps.",
                "The goal isn't to make a bot \"talk\" — it's to build a useful experience that responds, filters, and guides the customer without feeling robotic.",
              ],
            },
          ],
        },
        {
          key: "video",
          number: "02",
          label: "Video",
          railLabel: "Video",
          color: "orange",
          blurb: "Scripts that sell, and that people stay to watch until the end.",
          items: [
            {
              title: "Sales Video Scripts (VSL)",
              forQuien: [
                "Founders and startups selling online who need a video that explains their offer, handles objections, and moves the prospect toward a decision.",
              ],
              incluye: [
                "A complete 5-to-15-minute script, built around your offer and what your customer hesitates on before buying.",
                "Video editing included.",
              ],
            },
            {
              title: "Reels & Shorts Scripts",
              forQuien: [
                "Founders and B2B brands publishing short-form video who need to hook their audience in the first 3 seconds.",
              ],
              incluye: [
                "Scripts that hook from the first second and carry the idea through to the end.",
                "Video editing included.",
              ],
            },
            {
              title: "YouTube & Podcast Scripts",
              forQuien: [
                "Founders and experts who want to build authority and trust through long-form content, without losing relevance.",
              ],
              incluye: [
                "Structure and scripts that turn complex knowledge into episodes that are clear and easy to follow.",
                "Video editing included.",
              ],
            },
          ],
        },
        {
          key: "voz",
          number: "03",
          label: "Brand Voice",
          railLabel: "Brand Voice",
          color: "cobalt",
          blurb: "So your brand sounds like you, even when you're not the one writing.",
          items: [
            {
              title: "Executive Ghostwriting",
              forQuien: [
                "Founders and executives with experience, judgment, and ideas worth sharing, but no time or system to turn them into consistent content.",
              ],
              incluye: [
                "We turn how you think into first-person content for LinkedIn, articles, and other channels.",
              ],
            },
            {
              title: "Email & Newsletters",
              forQuien: [
                "Businesses that already have an audience, leads, or customers and want to stay top of mind without depending on the social media algorithm.",
              ],
              incluye: [
                "Newsletters, campaigns, and email sequences written around your voice, your ideas, and your offer.",
                "From editorial content that keeps the relationship alive, to emails built to drive the sale.",
              ],
            },
            {
              title: "Voice System",
              forQuien: [
                "Growing companies whose communication still shifts too much depending on who's writing, which channel they're using, or which AI tool is generating the content.",
              ],
              incluye: [
                "We define the tone and communication principles behind your brand so your website, emails, social, sales, and even your AI tools speak with one voice.",
                "An identity that's much harder to copy.",
              ],
            },
          ],
        },
      ],
      closing: {
        title: "Not sure which one you need?",
        paragraphs: [
          "You don't have to show up with a service list already picked out.",
          "Tell us what you're building and what problem you want to solve.",
        ],
        statement: "We find where value is leaking and we fix it.",
        cta: "Let's talk about your business",
      },
    },
    privacy: {
      meta: {
        title: "Privacy Policy — Malinois Writers",
        description: "Malinois Writers privacy policy.",
      },
      title: "Privacy Policy",
      updated: "Last updated: January 2026",
      body: [
        "Malinois Writers collects the information you voluntarily provide through our contact form (name, email, company, and the answers you share) solely to evaluate your request and respond to you.",
        "We do not sell or share your information with third parties for commercial purposes. Your data is used exclusively to manage communication between you and Malinois Writers.",
        "If at any point you'd like us to delete your information from our records, email us at digitalmedia@malinoisfilms.com and we'll do so within a reasonable timeframe.",
      ],
    },
  },
};

// Spanish is the primary language (lives at root).
export const ROUTES = {
  home: { es: "/", en: "/en" },
  about: { es: "/sobre", en: "/en/about" },
  contact: { es: "/contacto", en: "/en/contact" },
  services: { es: "/servicios", en: "/en/services" },
  privacy: { es: "/privacidad", en: "/en/privacy" },
};

export function getPageKeyFromPath(pathname) {
  for (const [key, paths] of Object.entries(ROUTES)) {
    if (paths.en === pathname || paths.es === pathname) return key;
  }
  return "home";
}

export function getLangFromPath(pathname) {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "es";
}
